import React from "react";
import UserSearchInput from "../pages/ClaudeAgent/UserSearchInput";
import RoleShareToggle from "../pages/ClaudeAgent/RoleShareToggle";
import "../pages/ClaudeAgent/ShareEnvironmentModal.css";

/**
 * Admin-set visibility for a global MCP server. Same three OR'd channels as
 * agents/environments (everyone, specific people, roles); `value` holds
 * { shared_with_everyone, shared_with_users, shared_with_roles }.
 */
export function mcpVisibilityLabel(server) {
  if (server.shared_with_everyone !== false) return "Everyone";
  const parts = [];
  const u = (server.shared_with_users || []).length;
  const r = server.shared_with_roles || [];
  if (u) parts.push(`${u} ${u === 1 ? "person" : "people"}`);
  if (r.length) parts.push(r.join(", "));
  return parts.length ? parts.join(" · ") : "Nobody";
}

export default function McpSharingFields({ value, onChange, idPrefix = "mcp" }) {
  const everyone = value.shared_with_everyone !== false;
  const users = value.shared_with_users || [];
  const roles = value.shared_with_roles || [];
  const set = (patch) => onChange({ ...value, ...patch });
  const addUser = (u) => {
    const email = (u.email || "").trim().toLowerCase();
    if (email && !users.includes(email)) set({ shared_with_users: [...users, email] });
  };
  return (
    <div className="form-group">
      <label>Visible to</label>
      <span className="share-everyone">
        <input
          type="checkbox"
          id={`${idPrefix}_shared_with_everyone`}
          checked={everyone}
          onChange={(e) => set({ shared_with_everyone: e.target.checked })}
        />
        <label htmlFor={`${idPrefix}_shared_with_everyone`}><strong>Everyone</strong></label>
      </span>
      {!everyone && (
        <>
          {users.length > 0 && (
            <div className="share-chips">
              {users.map((u) => (
                <span key={u} className="share-chip">
                  {u}
                  <button
                    type="button"
                    aria-label={`Remove ${u}`}
                    onClick={() => set({ shared_with_users: users.filter((x) => x !== u) })}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}
          <UserSearchInput onSelectUser={addUser} placeholder="Add a specific person…" />
          <div className="share-label">Roles</div>
          <RoleShareToggle value={roles} onChange={(r) => set({ shared_with_roles: r })} />
          {!users.length && !roles.length && (
            <div className="share-everyone-hint">Nobody can see this connector until you add people or roles.</div>
          )}
        </>
      )}
    </div>
  );
}
